import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-qitem-dialog',
  templateUrl: './manual-qitem-dialog.component.html',
  styleUrls: ['./manual-qitem-dialog.component.css'],
  standalone: false,
})
export class ManualQitemDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly projectDialogLink: string = AppConst.ROUTING_LINK_MANUAL_PROJECT_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
